import urlApiV2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

  getClassTheoryAwaitingProcessing (callback) {
    Vue.http.get(urlApiV2 + '/dashboard/turmas/aguardandoprocessamento')
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  getClassTheoryPending (callback) {
    Vue.http.get(urlApiV2 + '/dashboard/turmas/pendentes')
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  getClassPracticalPending (callback) {
    Vue.http.get(urlApiV2 + '/dashboard/aulas/praticas/pendentes')
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  getRegisteredStudentsByPeriod (year, callback) {
    Vue.http.get(urlApiV2 + `/dashboard/alunos/cadastrados?year=${year}`)
      .then(response => {
        if (response.data.sucesso) {
          callback(Object.values(response.data.alunos))
        }
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  exportClassPracticalPending (callback) {
    Vue.http.get(urlApiV2 + `/dashboard/aulas/praticas/planilha/pendentes`)
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  exportClassTheoryPending (callback) {
    Vue.http.get(urlApiV2 + `/dashboard/turmas/pendentes/export/csv`)
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.data.mensagem)
        callback(error.data)
      })
  },

  exportClassTheoryAwaitingProcessing (callback) {
    Vue.http.get(urlApiV2 + `/dashboard/turmas/aguardandoprocessamento/export/csv`)
      .then(response => {
        callback(response.body.dados)
      })
      .catch(error => {
        this.launchToast('fa-warning', error.mensagem)
        callback(error.body.data)
      })
  },

  getAulasQtde (data, callback) {
    Vue.http.get(`${urlApiV2}/dashboard/graficos/aulas?tipoAula=${data.tipoAula}&data=${data.data}&turno=${data.turno}&status=${data.status}&virtual=${data.virtual}`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        callback(error.data)
      })
  },

  getPendenciasQtde (data, callback) {
    Vue.http.get(`${urlApiV2}/dashboard/graficos/praticas-pendencias?schema=${data.cfc}&periodoI=${data.data[0]}&periodoF=${data.data[1]}`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        callback(error.data)
      })
  },

  // CARREGAR AUTO ESCOLAS
  async loadCfc () {
    let selectCFC = [
      { value: '', text: 'SELECIONE UMA AUTO ESCOLA' },
    ]

    Vue.http.get(`${urlApiV2}/autoescola`).then(response => {
      response.data.dados.map(autoescolas => {
        if (autoescolas.nome_fantasia !== 'TESTE') {
          selectCFC.push({
            value: autoescolas.tenant_schema,
            text: autoescolas.nome_fantasia,
          })
        }
      })
    })

    return selectCFC
  },

  // ALERT TOAST
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    })
  },

}
